import Image from '../component/Image/Image';

exports.resizeImage = Image.resizeImage;
// @deprecated
exports.Img = Image;
